import React from 'react';
export function LogoIcon({
  size = 48
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="drop-shadow-lg" data-id="element-358" data-mp="6jbj6tj7os4u">
      {/* Background rounded square with 3D effect */}
      <defs data-id="element-359" data-mp="fjridqsx9d3w">
        <linearGradient id="bg3d" x1="0" y1="0" x2="120" y2="120" gradientUnits="userSpaceOnUse" data-id="element-360" data-mp="fiyi98ogxluq">
          <stop offset="0%" stopColor="#2a2a2a" data-id="element-361" data-mp="pa2x88e596pk" />
          <stop offset="40%" stopColor="#1d1d1f" data-id="element-362" data-mp="p9b6bavhrx5m" />
          <stop offset="100%" stopColor="#0a0a0a" data-id="element-363" data-mp="13a40fuhvsq87" />
        </linearGradient>
        <linearGradient id="shine" x1="0" y1="0" x2="80" y2="80" gradientUnits="userSpaceOnUse" data-id="element-364" data-mp="13781q3y7lxip">
          <stop offset="0%" stopColor="white" stopOpacity="0.15" data-id="element-365" data-mp="351h1u9kn4fzi" />
          <stop offset="50%" stopColor="white" stopOpacity="0.03" data-id="element-366" data-mp="302np4jd6gt0e" />
          <stop offset="100%" stopColor="white" stopOpacity="0" data-id="element-367" data-mp="1qmto0443z3bi" />
        </linearGradient>
        <linearGradient id="textTop" x1="60" y1="20" x2="60" y2="60" gradientUnits="userSpaceOnUse" data-id="element-368" data-mp="1qkyzkftmot2o">
          <stop offset="0%" stopColor="#ffffff" data-id="element-369" data-mp="20jeuyuzouohz" />
          <stop offset="100%" stopColor="#b0b0b0" data-id="element-370" data-mp="25bg3c5tqjv2q" />
        </linearGradient>
        <linearGradient id="textBottom" x1="60" y1="62" x2="60" y2="100" gradientUnits="userSpaceOnUse" data-id="element-371" data-mp="25dj2bfcv8yjl">
          <stop offset="0%" stopColor="#999999" data-id="element-372" data-mp="2eatf555c0vqm" />
          <stop offset="100%" stopColor="#ffffff" data-id="element-373" data-mp="2jaxuusyf1mfs" />
        </linearGradient>
        <filter id="innerShadow" data-id="element-374" data-mp="2j9mtezsg0qru">
          <feOffset dx="0" dy="2" data-id="element-375" data-mp="2oatz8tb0zfvv" />
          <feGaussianBlur stdDeviation="1.5" data-id="element-376" data-mp="2o9snsnq3krdm" />
          <feComposite operator="out" in="SourceGraphic" data-id="element-377" data-mp="oxpygwusl2s1" />
          <feColorMatrix values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.4 0" data-id="element-378" data-mp="ozatenl0qnqf" />
          <feBlend in2="SourceGraphic" data-id="element-379" data-mp="tx2ti4vthg5p" />
        </filter>
        <filter id="textShadow" data-id="element-380" data-mp="lvlh8uh418oa">
          <feDropShadow dx="0" dy="1.5" stdDeviation="1" floodColor="#000" floodOpacity="0.5" data-id="element-381" data-mp="lwmpkr6qrh2b" />
        </filter>
      </defs>

      {/* 3D base shadow */}
      <rect x="4" y="6" width="112" height="112" rx="26" fill="#000" opacity="0.3" data-id="element-382" data-mp="vvc6ohqtcxhi" />

      {/* Main background */}
      <rect x="2" y="2" width="116" height="116" rx="26" fill="url(#bg3d)" data-id="element-383" data-mp="14tefvkkpawfv" />

      {/* Subtle border */}
      <rect x="2" y="2" width="116" height="116" rx="26" stroke="white" strokeOpacity="0.08" strokeWidth="1" fill="none" data-id="element-384" data-mp="zv36faybiny6" />

      {/* Shine overlay */}
      <rect x="2" y="2" width="116" height="116" rx="26" fill="url(#shine)" data-id="element-385" data-mp="19ns678kiaddo" />

      {/* Divider line */}
      <line x1="30" y1="62" x2="90" y2="62" stroke="white" strokeOpacity="0.12" strokeWidth="0.8" data-id="element-386" data-mp="1jjlrbgcajf72" />

      {/* NS text - top */}
      <text x="60" y="50" textAnchor="middle" fontFamily="Inter, system-ui, sans-serif" fontWeight="800" fontSize="34" letterSpacing="4" fill="url(#textTop)" filter="url(#textShadow)" data-id="element-387" data-mp="22631q1jesalz">
        NS
      </text>

      {/* AI text - bottom */}
      <text x="60" y="92" textAnchor="middle" fontFamily="Inter, system-ui, sans-serif" fontWeight="800" fontSize="34" letterSpacing="4" fill="url(#textBottom)" filter="url(#textShadow)" data-id="element-388" data-mp="1jho8d7lmcki0">
        AI
      </text>

      {/* Top-left corner accent dot */}
      <circle cx="18" cy="18" r="3" fill="white" opacity="0.15" data-id="element-389" data-mp="1ejcwysfoe1xo" />
    </svg>;
}